import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate, useSearchParams } from 'react-router'
import { toast } from 'sonner'

import { Loading } from '@/components/Loading'
import { Button } from '@/components/ui/button'
import { AuthCard, AuthLayout } from '@/layouts/AuthLayout'
import { useAuth } from '@/lib/auth'

export default function VerifyPage() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()
  const email = searchParams.get('email')
  const token = searchParams.get('token')

  const { loginNonce } = useAuth({
    middleware: 'guest',
    redirectTo: '/',
    tmp: 'VerifyPage',
  })
  const { t } = useTranslation(undefined, {
    keyPrefix: 'acceptInvite',
  })
  const [error, setError] = useState<string | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    if (!email || !token) {
      setError(t('error-no-params'))
      setIsLoading(false)
      return
    }

    // signIn('password-reset', {
    //   redirect: false,
    //   email: email,
    //   token: token,
    // })
    loginNonce({
      values: {
        email,
        token,
      },
      setError,
    })
      .then((response) => {
        setIsLoading(false)

        if (response?.status >= 400) {
          setError(t('error-failed'))

          return
        }

        if (response?.status === 200) {
          navigate(`/user/set-password?email=${email}&token=${token}`)
          return
        }

        console.log(`other response`, response)
        setError(t('error-other'))
      })
      .catch((error) => {
        console.log(`error`, error)
        toast.error(t('error'))
        navigate('/auth/login')
      })
  }, [email, token, navigate, t])

  return (
    <AuthLayout>
      <title>{t('title')}</title>

      <AuthCard
        title={error ? 'Pozvánku se nepodařilo přijmout' : t('title')}
        description={error ?? (isLoading ? 'Přihlašujeme vás, chvíli strpení.' : undefined)}
      >
        {isLoading && !error && <Loading spinnerSize={24} />}
        {error && (
          <div className="space-y-3">
            <p className="text-sm text-muted-foreground">Požádejte správce účtu o novou pozvánku, nebo se přihlaste, pokud už účet máte.</p>
            <Button asChild className="w-full">
              <Link to="/auth/login">Přejít na přihlášení</Link>
            </Button>
          </div>
        )}
      </AuthCard>
    </AuthLayout>
  )
}
